module.exports = __webpack_public_path__ + "static/media/notipayment.e849493f.svg";